import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
  FormControlLabel,
  Button,
  Slide,
  Card,
  Grid,
  CardContent,
  DialogActions,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
import { getToken } from '../../../utils/common';

const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = url;

const { de } = require('date-fns/locale');
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function DialogPreview(props) {
  const { open, data, handleClose, date, refresh, handleFileChange, handleUpload, files, type, path, filename } = props;
  const [selectedItems, setSelectedItems] = useState([]);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [dialogUploadPreview, setDialogUploadPreview] = React.useState({
    open: false,
    base64String: '',
    type: '',
    isLoading: true,
    path: '',
    isDownloading: false,
  });

  const handleDownload = async () => {
    // setDialogUploadPreview({ ...dialogUploadPreview, isDownloading: true });

    const url = URL.createObjectURL(dialogUploadPreview.blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}`;
    document.body.appendChild(link);

    // Trigger download
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    // setDialogUploadPreview({ ...dialogUploadPreview, isDownloading: false });
  };

  useEffect(() => {
    handlePreview(
      window.REACT_APP_API_PURE + `record/download/file/${encodeURIComponent(path?.replace(/\//g, '%2F'))}`,
      path
    );
  }, []);

  const handlePreview = async (fileUrl) => {
    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
      });

      if (!response.ok) {
        console.error(`Error downloading file: ${response.statusText}`);
        return;
      }

      const contentType = response.headers.get('Content-Type');
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const parts = filename.split('.');

      // Get the last part (the file extension)
      const fileExtension = parts[parts.length - 1];
      // Add the URL to the previews array

      setDialogUploadPreview({
        ...dialogUploadPreview,
        open: true,
        base64String: url,
        type: fileExtension,
        isLoading: false,
        path: path,
        blob: blob,
      });

      //   // ...prevPreviews,
      //   { url, type: 'png', path: path, filename: filename },
      // ]);

      // Clean up
      // URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error fetching file:', error);
    }
  };
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={'md'}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle></DialogTitle>
      <DialogContent style={{ backgroundColor: 'transparent', alignSelf: 'center' }}>
        {dialogUploadPreview.isLoading ? (
          <CircularProgress />
        ) : dialogUploadPreview.type === 'png' || dialogUploadPreview.type === 'jpg' ? (
          <img src={dialogUploadPreview.base64String} alt={`Preview `} style={{ transform: 'scale(1)' }} />
        ) : dialogUploadPreview.type === 'pdf' ? (
          <Document
            file={dialogUploadPreview.base64String}
            onLoadSuccess={(pdf) => {
              setTotalPages(pdf?.numPages);
            }}
          >
            {Array.from({ length: totalPages }, (_, i) => {
              if (!errorOccurred) {
                return (
                  <Page
                    key={i}
                    pageNumber={i + 1}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                    scale={1}
                    onRenderError={(error) => {
                      console.log(error);
                      secure = true;
                      // console.log(error);
                      // setErrorOccurred(true);
                    }}
                    height={document.getElementsByClassName('PdfDiv')[0]?.clientHeight * 0.8 ?? 150}
                  />
                );
              } else {
                return '';
              }
            })}
          </Document>
        ) : dialogUploadPreview.type === 'mp4' || dialogUploadPreview.type === 'video' ? (
          <video controls>
            <source src={dialogUploadPreview.base64String} type={`video/${dialogUploadPreview.type}`} />
          </video>
        ) : dialogUploadPreview.type === 'mp3' ? (
          <audio controls>
            <source src={dialogUploadPreview.base64String} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        ) : dialogUploadPreview.type === 'xlsx' || dialogUploadPreview.type === 'xls' ? (
          <iframe src={dialogUploadPreview.base64String} style={{ width: '100%', height: '500px' }}></iframe>
        ) : dialogUploadPreview.type === 'doc' || dialogUploadPreview.type === 'docx' ? (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${dialogUploadPreview.base64String}`}
            style={{ width: '100%', height: '500px' }}
          ></iframe>
        ) : (
          <p>Unsupported file type</p>
        )}
      </DialogContent>
      <DialogActions>
        <Grid container direction={'row'} spacing={2}>
          {/* <Grid item container direction={"row"}>
        <Grid item>go start</Grid>
        <Grid item>back</Grid>
        <Grid item>page number</Grid>
        <Grid item> of total</Grid>
        <Grid item>next</Grid>
        <Grid item>go end</Grid>
        </Grid> */}
          <Grid item>
            <Button style={{ color: 'white', backgroundColor: '#1eb3d9' }} onClick={handleClose}>
              Close
            </Button>
          </Grid>
          {!dialogUploadPreview.isLoading && (
            <Grid item>
              <Button style={{ color: 'white', backgroundColor: 'blue' }} onClick={handleDownload}>
                Download File
              </Button>
            </Grid>
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
